angular
  .module 'shared'
  .directive 'detectWindows', ($timeout) ->
    restrict: 'A'
    link: (scope, element) ->
      if window.navigator.appVersion.indexOf("Win") > -1
        element.addClass('fix-windows-fonts')
